// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` .Meetup-activationStepPanel-tqe2t {
 	max-width: 558px;
 	margin: 0 auto;
 	text-align: center;
 	padding: 74px 0px 0px 0px;
 }

 .Meetup-highlightedIcon-bbbIE {
 	border-width: 1px !important;
 	background-color: var(--primary-white-bg);
 	position: absolute;
 	border-width: 1px !important;
 	right: 42%;
 	top: 40px;
 	border-radius: 50%;
 	padding: 10px;
 	width: 100%;
 	max-width: 44px;
 	height: 44px;
 	-o-object-fit: none;
 	   object-fit: none;
 }

 .Meetup-profileImage-AeWms {
 	height: 130px;
 	width: 130px;
 	border-radius: 50%;
 }

 .Meetup-displayFlex-MlPLQ {
 	display: -webkit-box;
 	display: -ms-flexbox;
 	display: flex;
 	-webkit-box-align: center;
 	    -ms-flex-align: center;
 	        align-items: center;
 	-webkit-box-pack: center;
 	    -ms-flex-pack: center;
 	        justify-content: center;
 }`, "",{"version":3,"sources":["webpack://./src/components/Booking/Meetup/Meetup.css"],"names":[],"mappings":"CAAC;EACC,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;CAC1B;;CAEA;EACC,4BAA4B;EAC5B,yCAAyC;EACzC,kBAAkB;EAClB,4BAA4B;EAC5B,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,eAAe;EACf,YAAY;EACZ,mBAAgB;KAAhB,gBAAgB;CACjB;;CAEA;EACC,aAAa;EACb,YAAY;EACZ,kBAAkB;CACnB;;CAEA;EACC,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;CACxB","sourcesContent":[" .activationStepPanel {\n \tmax-width: 558px;\n \tmargin: 0 auto;\n \ttext-align: center;\n \tpadding: 74px 0px 0px 0px;\n }\n\n .highlightedIcon {\n \tborder-width: 1px !important;\n \tbackground-color: var(--primary-white-bg);\n \tposition: absolute;\n \tborder-width: 1px !important;\n \tright: 42%;\n \ttop: 40px;\n \tborder-radius: 50%;\n \tpadding: 10px;\n \twidth: 100%;\n \tmax-width: 44px;\n \theight: 44px;\n \tobject-fit: none;\n }\n\n .profileImage {\n \theight: 130px;\n \twidth: 130px;\n \tborder-radius: 50%;\n }\n\n .displayFlex {\n \tdisplay: flex;\n \talign-items: center;\n \tjustify-content: center;\n }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"activationStepPanel": `Meetup-activationStepPanel-tqe2t`,
	"highlightedIcon": `Meetup-highlightedIcon-bbbIE`,
	"profileImage": `Meetup-profileImage-AeWms`,
	"displayFlex": `Meetup-displayFlex-MlPLQ`
};
module.exports = ___CSS_LOADER_EXPORT___;
